import { isEmpty } from "lodash";
import React, { useContext, useEffect, useLayoutEffect, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation } from "react-router-dom";
import AuthProvider from "../context/AuthContext";
import BetSlipContext from "../context/BetSlipContext";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import OpenBetsDetails from "./OpenBetsDetails";
import axios from "axios";
import ParlyFIltered from "./ParlyFIltered";

function Openbets() {
  let { setOpenBetsToogle, openBetsToogle, openBetSelection, setLoader, user } =
    useContext(AuthProvider);
  let {
    messaageBox,
    refreshCurrentBet,
    setRefreshCurrentBets,
    isBetPlaced,
    setIsBetPlaced,
    setMessageBox,
    umMachedBetPlace,
    setUnMatchedBetPlace,
  } = useContext(BetSlipContext);
  const [parlayData, setParlayData] = useState([]);
  const [currentBets, setCurrentBets] = useState([]);
  const [betinfo, setBetInfo] = useState(false);
  const [sortbyTime, setSortbyTime] = useState(false);
  const [expandedMatch, setExpandedMatch] = useState(null);
  const [expandedParly, setExpandedParly] = useState(null);
  const { pathname } = useLocation();
  const [dockTarget, setDockTarget] = useState(null);

  useLayoutEffect(() => {
    const media = window.matchMedia("(min-width: 1024px)");
    const updateDock = () => setDockTarget(media.matches ? document.getElementById("desktop-open-bets") : null);
    updateDock();
    media.addEventListener("change", updateDock);
    return () => media.removeEventListener("change", updateDock);
  }, [pathname]);

  const getCurrentBets = async () => {
    if (!isEmpty(user)) {
      try {
        const promiseOne = await apiGet(apiPath.mobileCurrentBets);
        const promiseTwo = await apiGet(apiPath.currentParlay);
        
        const [betsResponse, parlayResponse] = await Promise.all([promiseOne, promiseTwo]);
        
        if (betsResponse.status === 200 && betsResponse.data.success) {
          setCurrentBets(betsResponse.data.results || []);
        }
        
        if (parlayResponse.status === 200 && parlayResponse.data.success) {
          setParlayData(parlayResponse.data.results || []);
        }
      } catch (error) {
        console.error('Error fetching bets:', error);
      }
    }
  };

  // console.log(currentBets, "currentBets");
  const sortTime = (check) => {
    setSortbyTime(check);
  };

  useEffect(() => {
    if (refreshCurrentBet) {
      setRefreshCurrentBets(false);
      getCurrentBets();
    }
  }, [refreshCurrentBet]);

  useEffect(() => {
    if (!isEmpty(user) && (openBetsToogle || dockTarget)) {
      getCurrentBets();
    }
    if (isEmpty(user)) {
      setCurrentBets([]);
      setParlayData([]);
    }
  }, [user, openBetsToogle, dockTarget]);

  const clearBets = async (id) => {
    setLoader(true);
    try {
      const response = await apiGet(`${apiPath.clearBets}matchBetId=${id}`);
      
      if (response.status === 200) {
        if (response.data.success) {
          setRefreshCurrentBets(true);
          setIsBetPlaced("clearBet");
          setMessageBox(true);
          getCurrentBets(); // Refresh the bets after clearing
        }
      }
    } catch (error) {
      console.error('Error clearing bet:', error);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (umMachedBetPlace) {
      setUnMatchedBetPlace(false);
    }
  }, [umMachedBetPlace]);

  // Events that actually have bets — used for the desktop "Select Market"
  // dropdown (and to resolve the displayed match name).
  const betEvents = (currentBets || [])
    .map((res, index) => {
      const hasBets =
        (res?.betList?.length ||
          res?.bookmakerList?.length ||
          res?.sessionBetList?.length ||
          res?.sportBookBetList?.length ||
          res?.tieBetList?.length ||
          res?.tossBetList?.length) > 0;
      if (!hasBets) return null;
      const nestedName =
        res?.betList?.[0]?.matchName ||
        res?.bookmakerList?.[0]?.matchName ||
        res?.sessionBetList?.[0]?.matchName ||
        res?.sportBookBetList?.[0]?.matchName ||
        "";
      return { index, matchName: res?.eventName || nestedName || "Other Bets" };
    })
    .filter(Boolean);

  // On desktop, default to the first event with bets so the Matched table shows
  // without needing a click (reference layout).
  useEffect(() => {
    if (dockTarget && expandedMatch == null && betEvents.length > 0) {
      setExpandedMatch(betEvents[0].index);
    }
  }, [dockTarget, betEvents.length]);

  // Which event's detail to render. Desktop falls back to the first event.
  const selectedIdx =
    expandedMatch != null ? expandedMatch : dockTarget && betEvents.length > 0 ? betEvents[0].index : null;

  const panel = (
    <>
      {(openBetsToogle || dockTarget) && (
        <div
          id="openBetsOverlay"
          className={dockTarget ? "open-bets-overlay open-bets-docked" : "open-bets-overlay"}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            // On mobile stop flush with the top of the bottom navigation bar
            // (no see-through gap); the bar + Sports dome are lifted above this
            // overlay via FooterNew's z-index while Open Bets is open.
            height: dockTarget ? "100%" : "calc(100% - 12.5vw)",
            backgroundColor: "rgba(0,0,0,0.8)",
            zIndex: 999999,
            display: "block",
          }}
        >
          <div
            id="openBetSlide"
            className="full-screen-content"
            style={{
              height: dockTarget ? "100vh" : "100%",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#fff"
            }}
          >
          <div
            id="sideHead"
            className="open-bets-heading"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flex: "0 0 40px",
              height: "40px",
              padding: "0 4px 0 14px",
              boxSizing: "border-box",
              borderRadius: 0,
              background: "var(--site-header-gradient)",
              color: "#000",
            }}
          >
            <h3
              style={{
                display: "block",
                margin: 0,
                padding: 0,
                background: "transparent",
                color: "#000",
                fontFamily: "Tahoma, Helvetica, sans-serif",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: 1,
              }}
            >
              Open Bets
            </h3>
            <button
              id="close"
              type="button"
              aria-label="Close open bets"
              onClick={() => setOpenBetsToogle(false)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                flex: "0 0 40px",
                width: "40px",
                height: "40px",
                margin: 0,
                padding: 0,
                border: 0,
                borderRadius: 0,
                background: "transparent",
                boxShadow: "none",
                color: "#000",
                cursor: "pointer",
              }}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M2 2L14 14M14 2L2 14" stroke="currentColor" strokeWidth="2" />
              </svg>
            </button>
          </div>

          <div id="sideContent" className="side-content" style={{ flex: 1, overflowY: "auto" }}>
              <ul
                id="eventMenuList"
                style={{ display: "block", margin: 0, padding: dockTarget ? "0" : "0 14px", listStyle: "none" }}
              >
                {/* ── DESKTOP: "Select Market" dropdown instead of accordion ─── */}
                {dockTarget && betEvents.length > 0 && (
                  <li style={{ display: "block", padding: "10px 12px 0", listStyle: "none" }}>
                    <div style={{ fontSize: "12px", color: "#555", marginBottom: "4px" }}>Select Market</div>
                    <select
                      value={selectedIdx}
                      onChange={(e) => setExpandedMatch(Number(e.target.value))}
                      style={{
                        width: "100%",
                        padding: "8px 10px",
                        fontSize: "13px",
                        border: "1px solid #c7ccd1",
                        borderRadius: "4px",
                        background: "#fff",
                        color: "#111",
                        cursor: "pointer",
                        outline: "none",
                      }}
                    >
                      {betEvents.map((ev) => (
                        <option key={ev.index} value={ev.index}>
                          {ev.matchName}
                        </option>
                      ))}
                    </select>
                  </li>
                )}

                {/* ── MOBILE: event title accordion list ─────────────────────── */}
                {!dockTarget &&
                  currentBets?.length > 0 &&
                  currentBets?.map((res, index) => {
                    const markets = [
                      { key: "BetFair", label: "BetFair", list: res?.betList },
                      { key: "Bookmaker", label: "Bookmaker", list: res?.bookmakerList },
                      { key: "Fancy", label: "Fancy", list: res?.sessionBetList },
                      { key: "SportsBook", label: "SportsBook", list: res?.sportBookBetList },
                      { key: "Tie", label: "Tie", list: res?.tieBetList },
                      { key: "Toss", label: "Toss", list: res?.tossBetList },
                    ].filter((m) => m.list?.length > 0);
                    if (markets.length === 0) return null;
                    const isOpen = expandedMatch === index;
                    const nestedName =
                      res?.betList?.[0]?.matchName ||
                      res?.bookmakerList?.[0]?.matchName ||
                      res?.sessionBetList?.[0]?.matchName ||
                      res?.sportBookBetList?.[0]?.matchName ||
                      "";
                    const matchName = (res?.eventName || nestedName || "Other Bets").toUpperCase();
                    return (
                      <li
                        key={index}
                        id={`eventMenuTemplate-match-${index}`}
                        className="inplay-off"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          borderBottom: "1px solid #e2e2e2",
                          padding: "12px 0",
                        }}
                      >
                        <a
                          onClick={() => setExpandedMatch(isOpen ? null : index)}
                          href="javascript:void(0)"
                          style={{
                            textDecoration: "none",
                            color: "#2789CE",
                            fontWeight: "bold",
                            fontSize: "14px",
                            fontFamily: "Tahoma, Helvetica, sans-serif",
                            flex: 1,
                            minWidth: 0,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            textTransform: "uppercase",
                          }}
                        >
                          {matchName}
                        </a>
                        <span
                          onClick={() => setExpandedMatch(isOpen ? null : index)}
                          style={{
                            width: "26px",
                            height: "26px",
                            border: "1px solid #d5d5d5",
                            borderRadius: 5,
                            background: "#FFFFFF",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#333",
                            cursor: "pointer",
                            flexShrink: 0,
                            marginLeft: "8px",
                          }}
                        >
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                            {isOpen ? (
                              <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                            ) : (
                              <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                            )}
                          </svg>
                        </span>
                      </li>
                    );
                  })}

                {/* ── Selected event detail — mobile: below list / desktop: below dropdown ─ */}
                {(() => {
                  if (selectedIdx == null) return null;
                  const res = currentBets?.[selectedIdx];
                  if (!res) return null;
                  const markets = [
                    { key: "BetFair", label: "BetFair", list: res?.betList },
                    { key: "Bookmaker", label: "Bookmaker", list: res?.bookmakerList },
                    { key: "Fancy", label: "Fancy", list: res?.sessionBetList },
                    { key: "SportsBook", label: "SportsBook", list: res?.sportBookBetList },
                    { key: "Tie", label: "Tie", list: res?.tieBetList },
                    { key: "Toss", label: "Toss", list: res?.tossBetList },
                  ].filter((m) => m.list?.length > 0);
                  if (markets.length === 0) return null;
                  return (
                    <li style={{ display: "block", padding: 0, listStyle: "none" }}>
                      {/* One unified Matched table for the whole match — all
                          market bets merged (fancy/sportsbook/toss rows
                          normalized to back/lay so they share the table). */}
                      <OpenBetsDetails
                        filtered={markets.flatMap((m) =>
                          m.list.map((b) => {
                            if (m.key === "Fancy")
                              return {
                                ...b,
                                betType: b?.type === "No" ? "lay" : "back",
                                isMatched: true,
                                _fancyOdds: true,
                                _sel: b?.fancyName,
                                _pl: b?.type === "No" ? b?.loseAmount : b?.profitAmount,
                              };
                            if (m.key === "SportsBook")
                              return {
                                ...b,
                                betType: "back",
                                isMatched: true,
                                _sel: b?.fancyName,
                                _sub: b?.runnerName,
                              };
                            if (m.key === "Toss") return { ...b, isMatched: true };
                            return b;
                          })
                        )}
                        sortbyTime={sortbyTime}
                        betinfo={betinfo}
                        betType="Matched"
                        type={"Matched"}
                        desktop={!!dockTarget}
                      />
                      {res?.betList?.some((b) => !b?.isMatched) && (
                        <OpenBetsDetails
                          filtered={res.betList.filter((b) => !b?.isMatched)}
                          sortbyTime={sortbyTime}
                          betinfo={betinfo}
                          betType="BetFair"
                          marketLabel="BetFair"
                          type={"UnMatched"}
                          clearBets={clearBets}
                          desktop={!!dockTarget}
                        />
                      )}
                      <div
                        style={{
                          display: "flex",
                          gap: "18px",
                          padding: "12px",
                          background: "#fff",
                        }}
                      >
                        <label style={{ display: "inline-flex", alignItems: "center", gap: "8px", cursor: "pointer", fontSize: "14px", color: "#111" }}>
                          <input
                            type="checkbox"
                            checked={betinfo}
                            onChange={() => setBetInfo(!betinfo)}
                            style={{
                              // Force native tick back — theme's `.style09 input`
                              // strips appearance and hides the checkmark.
                              appearance: "auto",
                              WebkitAppearance: "checkbox",
                              MozAppearance: "checkbox",
                              width: "16px",
                              height: "16px",
                              margin: 0,
                              accentColor: "#2789ce",
                              background: "initial",
                              border: "initial",
                              borderRadius: 0,
                              flex: "0 0 auto",
                              // Desktop: strip the legacy global input padding/inset
                              // shadow so it renders as a normal native checkbox.
                              ...(dockTarget ? { padding: 0, boxShadow: "none" } : {}),
                            }}
                          />
                          Bet Info
                        </label>
                      </div>
                    </li>
                  );
                })()}
                
                {parlayData?.length > 0 &&
                  parlayData?.map((res, index) => {
                    const isParlyOpen = expandedParly === index;
                    return (
                      <React.Fragment key={`parly-${index}`}>
                      <li
                        id={`eventMenuTemplate-parly-${index}`}
                        className="inplay-off"
                        style={{ display: "block", borderBottom: "1px solid #eee", padding: "10px" }}
                      >
                        <a
                          onClick={() => setExpandedParly(isParlyOpen ? null : index)}
                          href="javascript:void(0)"
                          style={{ textDecoration: "none", color: "#333", fontWeight: "bold" }}
                        >
                          Bet Placed -{" "}
                          {res?.bets?.length === 0
                            ? ""
                            : res?.bets?.length === 1
                            ? "SINGLE"
                            : res?.bets?.length === 2
                            ? "DOUBLE"
                            : res?.bets?.length === 3
                            ? "TREBLE"
                            : "ACCUMULATOR"}{" "}
                          - Parly
                        </a>
                      </li>
                      {isParlyOpen && (
                        <ParlyFIltered
                          filtered={res?.bets || []}
                          sortbyTime={sortbyTime}
                          betType="Parly"
                          betinfo={betinfo}
                          type={"Matched"}
                        />
                      )}
                      </React.Fragment>
                    );
                  })}
              </ul>
          </div>
        </div>
        </div>
      )}
    </>
  );
  return dockTarget ? createPortal(panel, dockTarget) : panel;
}

export default Openbets;
